module.exports = __webpack_public_path__ + "img/张凤荣.47e711a4.jpg";